import styled from "styled-components/macro";

export const Card = styled.div`
  border-radius: 20px;
  box-shadow: var(${(props) => (props.medium ? "--card-drop-shadow-medium" : "--card-drop-shadow")});
`;

Card.displayName = "Card";
